/* eslint-disable react-hooks/exhaustive-deps */
import {
  Paper,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useMemo, useState } from "react"
import qs from 'qs'
import { ListagemItem, Projeto } from "src/components/projetos/types"
import { Layout } from "src/components/projetos/_layouts"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { apiNoLoading } from "src/framework/providers/api"
import { setPersonalizadoTabDisabledStatus, setPersonalizadoTabDoneStatus } from "src/store/vendas/projetos/actions"
import theme from "src/theme/light"
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants"
import { useObservable } from "src/framework/store/storeUtil"
import { fraseParceiro$ } from "src/store/global.store"
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert"
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants"
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store"
import { FindInPageOutlined } from "@mui/icons-material"
import AcessoriosListMobile from "src/components/projetos/containers/Mobile/AcessoriosListMobile"
import { Componente, ID_CABO } from "src/components/componentes/types";

interface AcessoriosProps {
  onClickBack: () => void
  onClickNext: () => void
  formState: Projeto;
  onChangeFormState: (state: Projeto) => void
}

const useStyles = makeStyles({
  tableHeaderRow: {
    cursor: 'pointer'
  },
  warningText: {
    color: theme.palette.warning.main
  }
})

const Acessorios = ({ onClickBack, onClickNext, formState, onChangeFormState }: AcessoriosProps) => {
  const classes = useStyles()

  const [acessorios, setAcessorios] = useState<ListagemItem[]>(formState.acessorios || [])
  const [loading, setLoading] = useState(false)

  const fraseParceiroPowerAlert = useObservable(fraseParceiro$);
  
  const [fraseParceiroExibidoList] = useState<number[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(()=>{
    setLoading(true)
    apiNoLoading.get({
      url: '/estoque/categorias_componentes?grupo=acessorios'
    }).then(res => {
      const ids = res.data.map((item: any) => item.id)
      if (ids.length){

        const queryString = qs.stringify({
          categoria_componentes_id: ids.join(','),
          categoria_inversor_id: formState.tipo_inversor?.value,
          regiao_id: formState.regioes.length ? formState.regioes.map(item => item.id).join(',') : undefined,
          inversores_id: formState?.inversoresList?.filter(item => item?.quantidade > 0)?.map(item => item?.componente_id).join(','),
          segmento: formState.segmento?.includes("on") ? "on" : "off"
        })

        apiNoLoading.get({
          url: `/estoque/componentes/categorias?${queryString}`
        }).then(res => {
          const items = res.data || []
          const newAcessorios = items.map((item: Componente): ListagemItem => {
            const savedItem = (formState.acessorios || []).find(acessorio => acessorio.componente_id === item.id)
            return {
              componente_id: Number(item.id),
              nome: item.nome || '',
              descricao: item.descricao || '',
              quantidade: savedItem?.quantidade || 0,
              altura: Number(item.altura || 0),
              categoria_componentes_id: Number(item.categoria_componentes_id || 0),
              largura: Number(item.largura || 0),
              peso: Number(item.peso || 0),
              potencia: 0,
              valor: 0,
              valor_unitario: savedItem?.valor_unitario || 0,
              exibir_popup_parceiro: item.exibir_popup_parceiro || false,
            }
          })
          setAcessorios(newAcessorios)
        }).finally(() => setLoading(false))
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const handleChangeItemQuantity = useCallback((acessorioId: number, value: any) => {
    const state = {...formState}
    const newAcessorios = acessorios.map(acessorio => {
      if(acessorio.componente_id === acessorioId) {
        if(acessorio.exibir_popup_parceiro ) {
          const idx = fraseParceiroExibidoList.findIndex(c => c === acessorioId);
          if(idx < 0 && value > 0) {
            showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
            fraseParceiroExibidoList.push(acessorioId);
          } else {
            if(value === 0) {
              fraseParceiroExibidoList.splice(idx, 1);
            }
          }
        }
        return {
          ...acessorio,
          quantidade: value,
        }
      }
      return acessorio
    })
    state.acessorios = newAcessorios
    onChangeFormState(state)
    setAcessorios(newAcessorios)
  }, [formState, acessorios, onChangeFormState])

  const checkError = useCallback((categoriaIds: number, qtd: number): boolean => {
    if (categoriaIds !== ID_CABO) return false;
    if (qtd === 0) return false;
    if (qtd % 25 === 0) return false;
    return true
  },[])

  const nextButtonIsDisabled = useMemo(()=>{
    const cabos = acessorios.filter(item => item.categoria_componentes_id === ID_CABO)
    if (cabos.some(cabo => checkError(cabo.categoria_componentes_id, Number(cabo.quantidade)))) return true
    return false
  },[acessorios, checkError])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('finalizacao', nextButtonIsDisabled)
    setPersonalizadoTabDoneStatus('acessorios', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  const renderAcessorios = useCallback(() => {

    if (loading) {
      return (
        <div>Buscando acessórios...</div>
      )
    }

    if (isMobile) {
      return <AcessoriosListMobile 
        acessorios={acessorios}
        handleChangeQuantity={handleChangeItemQuantity}
        checkError={checkError}
      />
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell align='left'><strong>Acessórios disponíveis</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {acessorios.map(acessorio => (
              <TableRow key={acessorio.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Box textAlign={'left'}>
                      <Typography variant='body1' color='textPrimary'>
                        <strong>{acessorio.nome}</strong>
                      </Typography>
                      <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}><strong>Informações:</strong></span> {acessorio.descricao}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  <Box width="180px" margin={"0 auto"}>
                    <InputQuantidade hasError={checkError(acessorio.categoria_componentes_id, acessorio.quantidade)} multiple={acessorio.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1} value={acessorio.quantidade} onChange={(v: any) => handleChangeItemQuantity(acessorio.componente_id, v)} />
                    {acessorio.categoria_componentes_id === ID_CABO && checkError(acessorio.categoria_componentes_id, acessorio.quantidade) && (
                      <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                    )}
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton
                      onClick={() => acessorio.componente_id && modalComponentesDetalhesData$.next(acessorio.componente_id)}
                      size="large">
                        <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [loading, classes.tableHeaderRow, classes.warningText, acessorios, checkError, handleChangeItemQuantity])

  return (
    <Layout
      formState={formState}
      nextButtonIsDisabled={nextButtonIsDisabled}
      title="Acessórios"
      subtitle="Para que seu projeto fique completo, escolha os acessórios que atenderão a demanda do seu cliente." onClickBack={onClickBack} onClickNext={onClickNext}
    >
      <Box p={2}>
        {renderAcessorios()}
      </Box>
    </Layout>
  )
}

export { Acessorios }